import { useEffect, useState } from 'react';
import useTrimDetail from './queries/useTrimDetail';
import trimLevelsService from '../service/trimLevelsService';
import { ITrimSelectedLevel } from '../model/ITrimSelectedLevel';

const useSelectedTrimLevelName = (showMarketingPrefix = true) => {
  const [trimName, setTrimName] = useState('');
  const [selectedTrimLevels, setSelectedTrimLevels] = useState<ITrimSelectedLevel[]>([]);
  const { data, loading, error } = useTrimDetail();

  useEffect(() => {
    if (data) {
      const currentSelectedLevels = trimLevelsService.getCurrentSelectedLevels(data);
      setSelectedTrimLevels(currentSelectedLevels);
    }

    if (data) {
      const currentTrimLabel = data.trim.attributes.label;
      const marketingPrefix = data.trim.attributes.marketingprefix ?? '';
      const currentMarketingPrefix = showMarketingPrefix ? marketingPrefix : '';
      setTrimName(`${currentMarketingPrefix} ${currentTrimLabel}`);
    }
  }, [data]);

  return { trimName, data, loading, error, selectedTrimLevels };
};

export default useSelectedTrimLevelName;
